/** Dentrist brand colors sampled from src/images/logo/Dentrist-1-01.png */
export const brand = {
  primary: '#1FBAC2',
  primaryHover: '#1BA8B0',
  primaryActive: '#17969D',
  navy: '#00205C',
  navyDeep: '#00153D',
  soft: '#E6F7F9',
  muted: '#B3E4EA',
};

export const shell = {
  light: {
    layoutBg: '#FFFFFF',
    chromeBg: '#F3F8F9',
    contentBg: '#FFFFFF',
    border: '#D6E6E9',
    text: '#00153D',
    textMuted: '#5A6B7D',
    selectedBg: '#E6F7F9',
  },
  dark: {
    layoutBg: '#070D18',
    chromeBg: '#00205C',
    contentBg: '#070D18',
    border: 'rgba(0, 164, 180, 0.24)',
    text: '#FFFFFF',
    textMuted: '#A8B8C8',
    selectedBg: 'rgba(0, 164, 180, 0.2)',
  },
};

export const chart = {
  primary: brand.primary,
  secondary: brand.navy,
  /** Cool sage — positive / paid / invoices (harmonizes with teal) */
  success: '#3D9A8B',
  /** Dusty rose — negative / unpaid / expenses (softened vs neon red) */
  danger: '#C45C6A',
  tertiary: '#3D9A8B',
};

/** CSS custom properties for layout chrome (sidebar / header). */
export function getShellCssVars(mode) {
  const s = mode === 'dark' ? shell.dark : shell.light;
  return {
    '--dentrist-primary': brand.primary,
    '--dentrist-primary-hover': brand.primaryHover,
    '--dentrist-navy': brand.navy,
    '--dentrist-soft': brand.soft,
    '--dentrist-shell-bg': s.chromeBg,
    '--dentrist-layout-bg': s.layoutBg,
    '--dentrist-content-bg': s.contentBg,
    '--dentrist-border': s.border,
    '--dentrist-text': s.text,
    '--dentrist-text-muted': s.textMuted,
    '--dentrist-selected-bg': s.selectedBg,
  };
}

export function getAntdTheme(mode, { fontFamily } = {}) {
  const isDark = mode === 'dark';
  const s = isDark ? shell.dark : shell.light;

  return {
    token: {
      colorPrimary: brand.primary,
      colorPrimaryHover: brand.primaryHover,
      colorPrimaryActive: brand.primaryActive,
      colorInfo: brand.primary,
      colorLink: brand.primary,
      colorBgBase: s.layoutBg,
      colorBgContainer: isDark ? '#0F1A30' : '#FFFFFF',
      colorBgElevated: isDark ? '#132240' : '#FFFFFF',
      colorBorder: isDark ? 'rgba(255, 255, 255, 0.12)' : s.border,
      colorText: isDark ? '#FFFFFF' : s.text,
      colorTextSecondary: isDark ? s.textMuted : s.textMuted,
      colorTextQuaternary: isDark ? '#aeb0af' : '#828181',
      colorPrimaryBg: isDark ? brand.navy : brand.soft,
      borderRadius: 8,
      ...(isDark
        ? {
            controlOutlineWidth: 0,
            colorErrorBg: '#ff4d4f',
          }
        : {}),
      ...(fontFamily ? { fontFamily } : {}),
    },
  };
}
